// Centralized constants — keep in sync with backend server.py
// Updating in one place must propagate everywhere.

export const COUNTRIES = [
  "Austria",
  "Belgium",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czechia",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Ireland",
  "Italy",
  "Latvia",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "Norway",
  "Poland",
  "Portugal",
  "Romania",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
  "Switzerland",
  "United Kingdom",
];

export const LEAD_SOURCES = [
  "Manual",
  "Website",
  "Outscraper",
  "Apollo",
  "LinkedIn",
  "Referral",
  "Trade Fair",
  "Existing Customer",
  "Email Campaign",
  "Other",
];
